export default class Notify {
    constructor(message, type) {
        this.settings = {
            blockClass: "toast",
        };
        this.k = 0;
        this.height = 50;

        if (!document.querySelector(".toasts")) {
            var container = document.createElement("div");
            container.classList.add("toasts");
            container.style.cssText =
                "position: fixed; bottom: 15px; right: 15px; width: auto;z-index: 9999";
            document.body.appendChild(container);
        }

        var block = document.createElement("div");
        block.classList.add(this.settings.blockClass, type);

        block.style = "position: relative;width:auto;z-index: 9999;";
        block.setAttribute("data-closable", "");
        block.innerHTML =
            message +
            "<button class='close-button' type='button' data-close aria-label='Закрыть'><span aria-hidden='true'>&times;</span></button>";
        document.querySelector(".toasts").appendChild(block);

        document.body.appendChild(block);
        setTimeout(function() {
            block.remove();
        }, 2500);
    }
}